import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=c320a538&scoped=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c320a538",
  null
  
)

export default component.exports